const icon = state => state.icon;
const users = state => state.users;
const user = state => state.user;
const userRole = state => roleId => {
  return state.userRoles.find(li => li.id === roleId);
};

export default {
  icon,
  users,
  user,
  userRole
};
